import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-[15px] sm:pb-20 sm:pt-10" data-id="element-115" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-116" data-mp="9l375k8q6q7o">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-117" data-mp="4mi47d239sfj">
          Le programme d&apos;Arts Plastiques complet pour les enseignants
          francophones
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-navy sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-118" data-mp="nb6njukxbpp7">
          Préparez une année complète d&apos;Arts Plastiques en seulement{' '}
          <span className="italic text-grape" data-id="element-119" data-mp="3o6amdlpjdov7">5 minutes</span> chrono.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-navy/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-120" data-mp="399jmzcfv4d5l">
          <span className="sm:hidden" data-id="element-121" data-mp="359j8jrsrk1yj">
            9 volumes PDF prêts à l&apos;emploi, du CP à la 3ème. Imprimez,
            ouvrez et enseignez.
          </span>
          <span className="hidden sm:inline" data-id="element-122" data-mp="2vieuqvetqn5a">
            ARTS PRÊT™ est le système complet « clé en main » : 9 volumes PDF
            prêts à l&apos;emploi, riches en théorie visuelle, activités
            pratiques et évaluations, du CP à la 3ème. Il vous suffit
            d&apos;imprimer, d&apos;ouvrir et d&apos;enseigner.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-123" data-mp="s44e5chl11cm">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/088bdc26-bee0-48d0-aa02-d4f76c45a964.jpg" alt="Le pack ARTS PRÊT : 9 volumes imprimés, la version numérique sur ordinateur et tablette et les 5 bonus" className="mx-auto max-h-[34vh] w-full object-contain sm:max-h-none" data-id="element-124" data-mp="ddwzl7up42h7" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-3 sm:mt-8" data-id="element-125" data-mp="x14mju1wmg6w">
          <CtaButton label="Obtenir le pack ARTS PRÊT" href="#offre" data-id="element-126" data-mp="3hqu083qvfvy0" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-navy/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-127" data-mp="3htpzbveggqo1">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-128" data-mp="269he29hedd5e" data-mpi={index}>
                <span data-id="element-129" data-mp="2686cmgbfchhg">
                  <span aria-hidden="true" className="text-teal" data-id="element-130" data-mp="2b197qsvunyzr">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-navy/25" data-id="element-131" data-mp="2kxu8v34r0pyb">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}